import React from "react";
import { useLanguage } from "@/contexts/LanguageContext.jsx";

export default function InstitutionPatientReadOnlyField({ label, value, leadingSlot = null, children = null, multiline = false, className = "" }) {
  const { t } = useLanguage();
  const display = children ?? value ?? t("institutionPatientDetail.notSupplied", "Not supplied");
  return <div className={`institution-patient-readonly-field${multiline ? " is-multiline" : ""}${className ? ` ${className}` : ""}`}>
    <span className="institution-patient-readonly-field__label text-label-medium">{label}</span>
    <span className="institution-patient-readonly-field__value text-body-large">{leadingSlot}{display}</span>
  </div>;
}
